/* eslint-disable no-unused-vars */
/* eslint-disable react/forbid-prop-types */
import React, { useState, useRef, useEffect } from 'react';
import PropTypes from 'prop-types';
import { useMutation } from '@apollo/client';
import { IconButton } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import CircularProgress from '@mui/material/CircularProgress';
import StyledImgEditor from '@app/components/organisms/auth/UpdateProfile/imgEditor';
import { useTranslation } from '../../../../config/i18n';
import { ErrorList } from '../style';
import {
  Preview,
  IconContainer,
  UploaderContainer,
  Label,
  Container,
  PreviewContainer,
  Uploader,
  UploadIcon,
  LoadingIcon,
  StyledLabel,
} from './style';
import { UPLOAD_FILES } from '../../../../apollo/mutations';
import Typography from '../../../atoms/Typography';
import { colors } from '../../../../config/colors';
// import Typography from '../../atoms/Typography';

const ImageUploader = ({
  onChange,
  files,
  preview,
  icon,
  onClick,
  onIconClick,
  label,
  multiple,
  onImageClick,
  uploaderText,
  maxFileSize,
  id,
  disabled,
  autoUpload,
  value,
  maxCount,
  name,
  imageTextPosition,
  imageSizes,
}) => {
  const fileInputRef = useRef(null);

  // Array to store Images preview
  const [imagePreviewUrl, setImagePreviewUrl] = useState([]);

  // Upload file:
  const [
    uploadFiles,
    // {
    // loading: mutationLoading,
    // error: mutationError, data: mutationData
    // },
  ] = useMutation(UPLOAD_FILES, {
    onCompleted: (uploadedData) => {
      const { uploadFiles: uploadedFiles } = uploadedData;
      onChange(uploadedFiles);
      setImagePreviewUrl([]);
    },
  });

  const { t } = useTranslation(['warnings', 'applications', 'common', 'opportunity', 'account']);

  const [errors, setErrors] = useState([]);

  const handleClearError = (index) => () => {
    const newErrors = [...errors];
    newErrors.splice(index, 1);
    setErrors(newErrors);
  };

  // Recursion function that will read and validate files then it'll store their preview
  //  inside (imagePreviewUrl) State

  const readFiles = (fileItems) => {

    const newImagePreviewUrl = multiple ? imagePreviewUrl : [];
    let newCount = newImagePreviewUrl.length + fileItems.length;

    const readFile = (index) => {
      const reader = new FileReader();
      if (index >= fileItems.length) return;
      const file = fileItems[index];
      reader.onload = (ev) => {
        // get file content
        const bin = ev.target.result;

        // Validate file and store preview for the only validated files.
        if (ev.total < maxFileSize * 1024 * 1024) {
          newImagePreviewUrl.push(bin);
          if (newImagePreviewUrl.length === newCount) {
            setImagePreviewUrl([...newImagePreviewUrl]);
          }
        } else {
          newCount -= 1;
        }

        // do sth with bin
        readFile(index + 1);
      };
      if (file instanceof File || file instanceof Blob) {
        reader.readAsDataURL(file);
      }
    };

    readFile(0);
  };

  useEffect(() => {
    if (files.length > 0) {
      readFiles(files);
    }
  }, []);

  const handleImageChange = (e) => {
    e.preventDefault();
    const fileItems = Array.from(e.target.files);

    if (value.length + fileItems.length > maxCount) {
      setImagePreviewUrl([]);
      setErrors([...errors, t('file_count_error', { maxCount })]);
      return;
    }

    // Read and preview the files
    readFiles(fileItems);

    // console.log('fileItems ===> ', fileItems);

    // Validate files check file size
    const validFiles = fileItems.filter((fileIt) => {
      if (fileIt.size > maxFileSize * 1024 * 1024) {
        setErrors([
          ...errors,
          t('file_size_error', { filename: fileIt.name, maxSize: maxFileSize }),
        ]);
      }
      return fileIt.size < maxFileSize * 1024 * 1024;
    });

    // upload files and return Upload object
    if (autoUpload) {
      // console.log(validFiles);
      uploadFiles({
        variables: {
          files: validFiles,
        },
      });
    } else {
      onChange(validFiles);
    }
  };

  const open = () => {
    fileInputRef.current.click();
  };

  const [imgEditor, setImgEditor] = useState({
    show: false,
    finalImage: null,
    file: null,
    fileUrl: null,
  });

  const onPreviewClick = (clear, index) => {
    if(files[index]) {
      setImgEditor({ ...imgEditor, show: true, file: files[index] });
    }
  }

  useEffect(() => {
    if(imgEditor.finalImage) {
      setImagePreviewUrl([imgEditor.fileUrl])
      onChange([imgEditor.finalImage])
    }
  }, [imgEditor.finalImage])

  return (
    <Container>
      <PreviewContainer>
        {/* Preview the Uploader */}
        {(multiple || (!multiple && imagePreviewUrl.length === 0 && files.length === 0)) &&
          value.length < maxCount && (
            <UploaderContainer preview={preview} border="1px dashed #90a4ae">
              <StyledLabel top="-15px" left="10px">
                <Typography weight='700' variant="caption" color={colors.common.inBlack}>
                  {label}
                </Typography>
              </StyledLabel>
              <Uploader
                name={name}
                disabled={disabled}
                preview={preview}
                onClick={() => {
                  fileInputRef.current.click();
                  onClick();
                }}
              >
                <UploadIcon />
                {uploaderText}
              </Uploader>
              <StyledLabel bottom={imageTextPosition}>{imageSizes}</StyledLabel>
            </UploaderContainer>
          )}

        {/* Preview the files (string path) */}
        {((files.length > 0 && multiple) ||
          (!multiple && files.length > 0 && imagePreviewUrl.length === 0)) &&
          files.map((img, index) => {
            const clear = () => {
              // No Need to remove the cached preview of file of a blob.
            };
            if (typeof img === 'string') {
              return (
                <UploaderContainer preview={preview} id={`${id}-preview-${index}`}>
                  <IconContainer preview={preview} onClick={() => onIconClick(open, clear, index)}>
                    {icon}
                  </IconContainer>
                  <Preview
                    preview={preview}
                    onClick={() => onPreviewClick( clear, index) }
                    src={img || (files.length > 0 && files[index])}
                  />
                  <StyledLabel bottom={imageTextPosition}>{imageSizes}</StyledLabel>
                </UploaderContainer>
              );
            }
            return <></>;
          })}

        {/* Preview the files (Blob or File) */}
        {imagePreviewUrl.length > 0 &&
          imagePreviewUrl.map((img, index) => {
            const newIndex =
              value.length > 0 ? value.length - imagePreviewUrl.length + 1 + index : index;
            // const newIndex = index;
            // For removing the cached preview of file of a blob.
            const clear = () => {
              const newImagePreviewUrl = [...imagePreviewUrl];
              newImagePreviewUrl.splice(index, 1);
              setImagePreviewUrl(newImagePreviewUrl);
            };

            // console.log('newIndex', newIndex);

            // const isUploading = value ? mutationLoading && newIndex >= value.length : false;
            const isUploading = autoUpload;
            return (
              // isUploading && ( ???? this is strange

              <UploaderContainer preview={preview} id={`${id}-preview-${index}`}>
                {!isUploading && (
                  <IconContainer
                    preview={preview}
                    onClick={() => onIconClick(open, clear, newIndex)}
                  >
                    {icon}
                  </IconContainer>
                )}
                <Preview
                  uploading={isUploading}
                  preview={preview}
                  onClick={() => onPreviewClick(clear, newIndex)}
                  src={img || (files.length > 0 && files[index])}
                />
                {isUploading && (
                  <LoadingIcon>
                    <CircularProgress color="primary" />
                    <Typography variant="body1" color="primary">
                      {t('common:uploading')} ...
                    </Typography>
                  </LoadingIcon>
                )}
                <StyledLabel bottom={imageTextPosition}>{imageSizes}</StyledLabel>
              </UploaderContainer>
            );

            // );
          })}

        <input
          name={name}
          id={id}
          disabled={disabled}
          hidden
          ref={fileInputRef}
          type="file"
          multiple={multiple}
          onChange={handleImageChange}
          accept="image/png, image/jpeg, image/jpg"
        />
      </PreviewContainer>
      {errors.length > 0 && (
        <ErrorList>
          {errors.map((error, index) => (
            <li>
              {error}
              <IconButton size="small" onClick={handleClearError(index)}>
                <CloseIcon fontSize="small" />
              </IconButton>
            </li>
          ))}
        </ErrorList>
      )}
      {imgEditor.show && (
        <StyledImgEditor imgEditor={imgEditor} setImgEditor={setImgEditor} />
      )}

    </Container>
  );
};

ImageUploader.propTypes = {
  onChange: PropTypes.func.isRequired,
  preview: PropTypes.string,
  files: PropTypes.arrayOf(PropTypes.string),
  icon: PropTypes.node,
  onIconClick: PropTypes.func,
  // eslint-disable-next-line react/forbid-prop-types
  onClick: PropTypes.func,
  onImageClick: PropTypes.func,
  label: PropTypes.string,
  multiple: PropTypes.bool,
  uploaderText: PropTypes.element,
  maxFileSize: PropTypes.number,
  id: PropTypes.string,
  disabled: PropTypes.bool,
  maxCount: PropTypes.number,
  autoUpload: PropTypes.bool,
  value: PropTypes.array,
  name: PropTypes.string,
  imageTextPosition: PropTypes.string,
  imageSizes: PropTypes.element,
};

ImageUploader.defaultProps = {
  preview: 'square',
  files: [],
  icon: null,
  onClick: () => {},
  onIconClick: () => {},
  onImageClick: () => {},
  label: '',
  multiple: false,
  uploaderText: null,
  maxFileSize: 20,
  id: undefined,
  maxCount: 10,
  disabled: false,
  autoUpload: true,
  value: [],
  name: '',
  imageTextPosition: '-80px',
  imageSizes: null,
};

export default ImageUploader;
